import {performHttpRequest} from "../http";

export async function getMutationInfo(domainID, presentationID, formID) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/mutation/' + formID + '',
        'GET'
    )
}

export async function postMutationFileSmall(domainID, presentationID, formID, data) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + domainID + '/presentation/' + presentationID + '/mutation/' + formID + '/upload/small',
        'POST',
        data
    )
}
